import { writable } from "svelte/store";

export const selectCharacterSceneVisibleStore = writable(false);
export const selectCharacterCustomizeSceneVisibleStore = writable(false);
